module.exports = __webpack_public_path__ + "static/media/Q2_Front_Left.c1d0d3df.png";